import { CancelButton, Card, CommandButton } from "components"
import { AttachmentModal } from "./AttachmentModal"
// import { useParams } from "react-router-dom"
// import { useFormContext, useWatch } from "react-hook-form"
// import { PaymentDepositCustomerType } from "../types"
import { Print } from "./Print"

type CommandButtonsProps = {
  approvalView?: boolean
  showDeleteButton?: boolean
  showSaveButton?:boolean | true
  onDelete?: () => void
  onSave?: () => void
}

export const CommandButtons = ({
  approvalView,
  showDeleteButton,
  showSaveButton,
  onDelete,
  onSave
}: CommandButtonsProps) => {
  // const { deposit_customer_id } = useParams()

  // const { control } = useFormContext<PaymentDepositCustomerType>()
  // const approval_status = useWatch({ control, name: "approve_status" })

  return (
    <Card className={approvalView ? "hidden" : ""}>
      <Card.Body className="flex flex-col gap-5">
        <section className="flex flex-wrap justify-between gap-3">
          <section className="flex flex-wrap gap-3">
            {/* {deposit_customer_id && approval_status === 4 ? <Print /> : <CommandButton actiontype="print" />} */}
            <Print />
            <AttachmentModal />
          </section>

          <section className="flex flex-wrap gap-3">
            <CancelButton />
            {showDeleteButton && (
              <CommandButton actiontype="delete" onClick={onDelete} />
            )}

            {showSaveButton && (
              <CommandButton
                actiontype="save"
                type="button"
                color="primary"
                permission="ST121"
                onClick={onSave}
              />
            )}
          </section>
        </section>
      </Card.Body>
    </Card>
  )
}
